var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOpenTrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0219 13.1758H10.8098C9.71752 13.1758 8.83203 14.0412 8.83203 15.1088V26.0671C8.83203 27.1347 9.71752 28.0001 10.8098 28.0001H22.0219C23.1142 28.0001 23.9997 27.1347 23.9997 26.0671V15.1088C23.9997 14.0412 23.1142 13.1758 22.0219 13.1758Z",
    fill: "url(#paint0_linear_1640_38164)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.265 0H2.14193C0.958975 0 0 0.937267 0 2.09345V23.8127C0 24.9688 0.958975 25.9061 2.14193 25.9061H17.265C18.448 25.9061 19.407 24.9688 19.407 23.8127V2.09345C19.407 0.937267 18.448 0 17.265 0Z",
    fill: "url(#paint1_linear_1640_38164)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.265 0H2.14193C0.958975 0 0 0.937267 0 2.09345V23.8127C0 24.9688 0.958975 25.9061 2.14193 25.9061H17.265C18.448 25.9061 19.407 24.9688 19.407 23.8127V2.09345C19.407 0.937267 18.448 0 17.265 0Z",
    fill: "url(#paint2_linear_1640_38164)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38164)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1640_38164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0219 13.1758H10.8098C9.71752 13.1758 8.83203 14.0412 8.83203 15.1088V26.0671C8.83203 27.1347 9.71752 28.0001 10.8098 28.0001H22.0219C23.1142 28.0001 23.9997 27.1347 23.9997 26.0671V15.1088C23.9997 14.0412 23.1142 13.1758 22.0219 13.1758Z",
    fill: "url(#paint3_linear_1640_38164)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5352 5.59551H5.87222C5.4612 5.59551 5.12793 5.26978 5.12793 4.86806C5.12793 4.46635 5.4612 4.14062 5.87222 4.14062H13.5352C13.9462 4.14062 14.2794 4.46635 14.2794 4.86806C14.2794 5.26978 13.9462 5.59551 13.5352 5.59551Z",
    fill: "#7BF8D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5352 9.59941H5.87222C5.4612 9.59941 5.12793 9.27369 5.12793 8.87197C5.12793 8.47026 5.4612 8.14453 5.87222 8.14453H13.5352C13.9462 8.14453 14.2794 8.47026 14.2794 8.87197C14.2794 9.27369 13.9462 9.59941 13.5352 9.59941Z",
    fill: "#7BF8D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38164",
    x: 4.83203,
    y: 9.17578,
    width: 23.1675,
    height: 22.8242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1640_38164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38164",
    x1: 23.4204,
    y1: 13.7424,
    x2: 9.73243,
    y2: 27.7474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38164",
    x1: 0,
    y1: 12.9531,
    x2: 19.407,
    y2: 12.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38164",
    x1: 0,
    y1: 12.9531,
    x2: 19.407,
    y2: 12.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38164",
    x1: 18.5002,
    y1: 14.0005,
    x2: 9.72394,
    y2: 27.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70FFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpenTrades);
export default __webpack_public_path__ + "static/media/menu-open-trades.32a2edc2bd639631fdc96eaa7e6a51b7.svg";
export { ForwardRef as ReactComponent };